import { render } from "./PolicyRightView.vue?vue&type=template&id=190421aa&scoped=true"
import script from "./PolicyRightView.vue?vue&type=script&lang=js"
export * from "./PolicyRightView.vue?vue&type=script&lang=js"

import "./PolicyRightView.vue?vue&type=style&index=0&id=190421aa&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190421aa"]])

export default __exports__